import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cafe-menu',
  templateUrl: './cafe-menu.component.html',
  styleUrls: ['./cafe-menu.component.scss']
})
export class CafeMenuComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
